var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSignedEmployed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15986_21646)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76764 3.66667C6.54034 3.66667 5.54541 4.66159 5.54541 5.88889C5.54541 7.11619 6.54034 8.11111 7.76764 8.11111C8.99494 8.11111 9.98986 7.11619 9.98986 5.88889C9.98986 4.66159 8.99494 3.66667 7.76764 3.66667ZM3.87875 5.88889C3.87875 3.74111 5.61986 2 7.76764 2C9.91541 2 11.6565 3.74111 11.6565 5.88889C11.6565 8.03666 9.91541 9.77778 7.76764 9.77778C5.61986 9.77778 3.87875 8.03666 3.87875 5.88889Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76764 12.5556C5.84147 12.5556 4.06671 13.5998 3.13128 15.2836L2.79501 15.8889H9.94526C10.4055 15.8889 10.7786 16.262 10.7786 16.7222C10.7786 17.1825 10.4055 17.5556 9.94526 17.5556H2.48839C1.35515 17.5556 0.638819 16.3382 1.18917 15.3475L1.67435 14.4742C2.90373 12.2613 5.23619 10.8889 7.76764 10.8889V11.7222C7.76764 10.8889 7.76764 10.8889 7.76764 10.8889L7.77023 10.8889L7.77425 10.8889L7.78645 10.889L7.82679 10.8896C7.86043 10.8902 7.90739 10.8915 7.96516 10.894C8.08028 10.8989 8.24063 10.9087 8.42578 10.9282C8.78258 10.9659 9.28709 11.0451 9.74156 11.2254C10.1694 11.3951 10.3786 11.8794 10.2089 12.3073C10.0392 12.7351 9.55486 12.9443 9.12705 12.7746C8.88121 12.6771 8.55238 12.6175 8.25092 12.5857C8.10695 12.5705 7.98194 12.5629 7.89398 12.5591C7.85022 12.5573 7.8162 12.5564 7.79426 12.5559L7.77086 12.5556L7.76764 12.5556Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 9.90468C19.117 9.68772 19.117 9.33597 18.9 9.11901L17.7215 7.9405C17.5046 7.72354 17.1528 7.72354 16.9358 7.9405L15.8724 9.00396L17.8366 10.9681L18.9 9.90468Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0509 11.7538L15.0867 9.78963L12.3656 12.5107C11.9508 12.9256 11.7168 13.4877 11.7148 14.0744L11.7121 14.8497C11.7115 15.0039 11.8367 15.129 11.9908 15.1284L12.7662 15.1258C13.3529 15.1237 13.915 14.8898 14.3298 14.4749L17.0509 11.7538Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15986_21646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignedEmployed);
export default __webpack_public_path__ + "static/media/iconSignedEmployed.0badab99ccaab8ca9f2d12faf06e49c9.svg";
export { ForwardRef as ReactComponent };